import BaseModel from '../base/BaseModel.model';
import RecordTag from './recordTag.model';
export default class Tag extends BaseModel {

    public name?: string;
    public recordTags: Array<RecordTag>;
    
    constructor() {
        super();
        this.init();
    }

    init() {
        this.name = null;
        this.recordTags = [];
    }
}